const state = {
  filter: {},
}

const actions = {
  setFilter({ commit }, data) {
    commit('SET_FILTER', data)
  },
}

const mutations = {
  SET_FILTER(state, payload) {
    state.filter = payload
  },
}

const getters = {
  getFilter: (state) => {
    return state.filter
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
